// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__2Hj-D","inputWrap":"styles_inputWrap__2B1yN","input":"styles_input__2Bfn3"};